"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PHONE_CODE_SENDER_TO_LABEL = void 0;
var _sendCode = require("../../api/sendCode");
const PHONE_CODE_SENDER_TO_LABEL = exports.PHONE_CODE_SENDER_TO_LABEL = {
  [_sendCode.ESenderType.Sms]: 'sms',
  [_sendCode.ESenderType.Call]: 'last_phone_numbers'
};